import { render, staticRenderFns } from "./Multichart.vue?vue&type=template&id=681fde1e&"
import script from "./Multichart.vue?vue&type=script&lang=js&"
export * from "./Multichart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports